export type TransformSymbolTradingStateChangeDataType = {
  Isin: string;
  TradingStatus: number;
};

function transformSymbolTradingStateChange(
  data: TransformSymbolTradingStateChangeDataType
) {
  const { Isin: isin, TradingStatus: instrumentTradingState } = data;

  return {
    isin,
    instrumentTradingState,
  };
}

export { transformSymbolTradingStateChange };
